/* Round 46: request Shopify-filtered results; never trim an already paginated grid. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) { root.InStockyAvailability = api; api.init(root); }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  function isCollection(path) {
    return /\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(path) && path.indexOf('/products/') === -1;
  }
  function normalize(raw, base, resetPage) {
    var current = new URL(raw, base), original = new URL(base);
    if (current.origin !== original.origin) return current;
    var changed = false;
    if (isCollection(current.pathname)) {
      if (current.pathname.replace(/\/+$/, '') === '/collections/all' && !current.searchParams.has('sort_by')) {
        current.searchParams.set('sort_by', 'created-descending'); changed = true;
      }
      if (current.searchParams.get('filter.v.availability') !== '1' || current.searchParams.getAll('filter.v.availability').length !== 1) {
        current.searchParams.set('filter.v.availability', '1'); changed = true;
      }
    } else if (/\/search\/?$/.test(current.pathname) && (current.searchParams.get('q') || '').trim()) {
      if (current.searchParams.get('options[unavailable_products]') !== 'hide') {
        current.searchParams.set('options[unavailable_products]', 'hide'); changed = true;
      }
    }
    if (changed && resetPage) current.searchParams.delete('page');
    return current;
  }
  function init(win) {
    var data = win.InStockyBrowseConfig || {}, here = new URL(win.location.href);
    var needsDefault = data.pageType === 'search' || (data.pageType === 'collection' && data.collectionFilterEnabled);
    if (needsDefault && !here.searchParams.has('view')) {
      var target = normalize(here.href, here.href, true);
      if (target.href !== here.href) win.location.replace(target.href);
    }
    function updateLink(anchor) {
      if (!anchor || !anchor.href || anchor.hasAttribute('download')) return;
      // Never reset explicit paging links; Shopify generated them from filtered results.
      var next = normalize(anchor.href, win.location.href, false);
      if (next.href !== anchor.href) anchor.href = next.href;
    }
    function ready() {
      win.document.querySelectorAll('a[href]').forEach(updateLink);
      win.document.addEventListener('click', function (event) {
        var anchor = event.target.closest ? event.target.closest('a[href]') : null;
        updateLink(anchor);
      }, true);
    }
    if (win.document.readyState === 'loading') win.document.addEventListener('DOMContentLoaded', ready);
    else ready();
  }
  return { isCollection: isCollection, normalize: normalize, init: init };
});
